import { cn } from "@/utils/classes";
import { LockClosedIcon } from "@heroicons/react/20/solid";

/* Prop Types */
interface PadlockIconProps {
  iconClassName?: string;
  className?: string;
  isGradient?: boolean;
}

/**
 * Padlock Icon
 * Used to indicate secure or locked content normally behind a feature flag
 * @param iconClassName - Additional classes for the icon itself
 * @param className - Additional classes for the container
 */
export const PadlockIcon = ({ iconClassName, className, isGradient = false }: PadlockIconProps) => {
  return isGradient ? (
    <svg width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M3.5 0C4.74264 0 5.75 1.00736 5.75 2.25V4H6C6.55228 4 7 4.44772 7 5V8C7 8.55228 6.55228 9 6 9H1C0.447715 9 0 8.55228 0 8V5C0 4.44772 0.447715 4 1 4H1.25V2.25C1.25 1.00736 2.25736 0 3.5 0ZM3.5 0.75C2.67157 0.75 2 1.42157 2 2.25V4H5V2.25C5 1.42157 4.32843 0.75 3.5 0.75Z"
        fill="url(#paint0_linear_15042_11753)"
      />
      <defs>
        <linearGradient id="paint0_linear_15042_11753" x1="-4" y1="0.5" x2="5.68918" y2="-1.08308" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4E499C" />
          <stop offset="1" stopColor="#F2318A" />
        </linearGradient>
      </defs>
    </svg>
  ) : (
    <div className={cn("p-1.5 bg-base-200 rounded-full flex items-center justify-center", className)}>
      <LockClosedIcon className={cn(`size-2.5 flex-shrink-0 ${iconClassName}`)} />
    </div>
  );
};
